import React, { useState } from "react";
import PerformanceHeader from "./PerformanceHeader";
import TrafficSource from "./TrafficSource";
import KeyMatrix from "./KeyMatrix";
import { Tabs } from "@metacrm/metacrm-material-ui/dist/Tabs";
import { Box } from "@mui/material";
import { useIntl } from "react-intl";

export default function DAppTraffic() {
  const { formatMessage } = useIntl();
  const [value, setValue] = useState(0);

  function handleChange(event, newValue) {
    setValue(newValue);
  }

  const tabs = [
    {
      label: formatMessage({ id: "websiteTraffic.tab.keyMetrix" }),
      content: <KeyMatrix />,
      _id: 1,
    },
    {
      label: formatMessage({ id: "websiteTraffic.tab.trafficSource" }),
      content: <TrafficSource />,
      _id: 2,
    },
  ];

  return (
    <div>
      <PerformanceHeader />
      <Box mt="26px">
        <Tabs
          className="fade-up-more"
          tabs={tabs}
          value={value}
          onChange={handleChange}
        />
      </Box>
    </div>
  );
}
